import { Plugins } from '@capacitor/core';
import { isPlatform } from '@ionic/react';
import type { CalendarEventData } from 'application/pages/BookingDetailsModal/ICalendarAdapter';
import type ICalendarAdapter from 'application/pages/BookingDetailsModal/ICalendarAdapter';
import { ics } from 'calendar-link';
import type { CapacitorCalendarPlugin } from 'capacitor-calendar/src';
import FileSaver from 'file-saver';

// Used deprecated 'Plugins' to keep compatibility with 'capacitor-calendar'
const Calendar = Plugins.CapacitorCalendar as
  | CapacitorCalendarPlugin
  | undefined;

const NativeCalendarAdapter: ICalendarAdapter = {
  async addTreatmentToCalendar(eventData: CalendarEventData): Promise<void> {
    if (isPlatform('capacitor') && Calendar) {
      await Calendar.createEvent({
        startDate: eventData.start.valueOf(),
        endDate: eventData.end.valueOf(),
        title: eventData.name,
        notes: eventData.description,
        location: eventData.location,
      });
      return;
    }

    const icsData = ics({
      start: eventData.start,
      end: eventData.end,
      title: eventData.name,
      description: eventData.description,
      location: eventData.location,
    });

    FileSaver.saveAs(icsData, 'soulhouse.ics');
  },
};

export default NativeCalendarAdapter;
